<template>
    <div class="card-brand">
        <img v-if="brand === CardBrands.AMEX" src="@/assets/img/brands/amex-v2.svg" alt="Amex" />
        <img v-if="brand === CardBrands.DINERS" src="@/assets/img/brands/diners-v2.svg" alt="Diners" />
        <img v-if="brand === CardBrands.ELO" src="@/assets/img/brands/elo-v2.svg" alt="Elo" />
        <img v-if="brand === CardBrands.MASTERCARD" src="@/assets/img/brands/mastercard-v2.svg" alt="MasterCard" />
        <img v-if="brand === CardBrands.VISA" src="@/assets/img/brands/visa-v2.svg" alt="Visa" />
        <img v-if="brand === CardBrands.ALELO" src="@/assets/img/brands/alelo.svg" alt="Alelo" />
        <img v-if="brand === CardBrands.PATELOVOUCHER" src="@/assets/img/brands/elo-v2.svg" alt="Pat Elo Voucher" />
        <img v-if="brand === CardBrands.DISCOVER" src="@/assets/img/brands/discover.svg" alt="Discover" />
        <img v-if="brand === CardBrands.JCB" src="@/assets/img/brands/jcb.svg" alt="JCB" />
    </div>
</template>

<script>
    import CardBrands from '@/models/CardBrands';

    export default {
        props: {
            brand: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                CardBrands
            };
        }
    };
</script>

<style scoped>
    .card-brand img {
        width: 40px;
        height: 24px;
    }
</style>
